import React, { useEffect, useState } from "react";

import { goTo, triggerTrengo, triggerTrengoContactData, useAppType, useNavigate, useTranslation, useUserContext } from "utils";

import { appVersions } from "enums";

import { Avatar, AvatarImage, Drawer, Icon, IconLinkButton, Link } from "components";

export const NavDrawer = ({ visible, onClose }) => {
  const { t } = useTranslation("nav");
  const { user } = useUserContext();

  const appType = useAppType();
  const navigate = useNavigate();

  const [trengo, setTrengo] = useState(false);
  const [year] = useState(new Date().getFullYear());

  useEffect(() => {
    if (window.Trengo) {
      window.Trengo.on_close = () => {
        setTrengo(false);
      };
    }
  }, [setTrengo]);

  const marginTop = !appType.desktop ? "margin-top-250" : "margin-top-300";
  return (
    <Drawer
      dataTestId="nav-drawer"
      className="nav-drawer"
      isNavDrawer
      title=""
      visible={visible}
      wide={appType.mobile}
      onClose={onClose}
      logoUrl={"/dashboard"}
    >
      <>
        {/* Profile */}
        <div className="drawer-row">
          <div>
            {user && user.image && user.image !== "false" ? (
              <AvatarImage image={user.image} size="m" onClick={() => goTo(null, navigate, "/user")} />
            ) : (
              <Avatar size="m" name={`${user.firstName} ${user.lastName}`} onClick={() => goTo(null, navigate, "/user")} />
            )}
          </div>
          <div>
            <h2 className="pointer" onClick={() => goTo(null, navigate, "/user")}>{`${user.firstName} ${user.lastName}`}</h2>
            <Link to={"/user"} onClick={onClose}>
              {t("drawer.viewProfile")}
            </Link>
          </div>
        </div>

        {/* Navigation links */}
        <div className={`drawer-col ${marginTop}`}>
          <div className="drawer-row with-icon pointer">
            <Icon iconName="tabler/file" />
          </div>
          <div className="drawer-row with-icon pointer">
            <Icon iconName="tabler/settings" />
            <Link to="/user/settings" onClick={onClose} mixpanelText={t("drawer.settings")}>
              <h3>{t("drawer.settings")}</h3>
            </Link>
          </div>
        </div>

        {/* Support */}
        <div className={`do-you-need-help ${marginTop}`}>
          <div className="padding-100">
            <p>
              <span className="grey-text inline">{t("drawer.needHelp")}</span>
            </p>
            <div className="drawer-col">
              <div className="drawer-row with-icon pointer">
                <Icon iconName="tabler/help" />
                <h6 onClick={() => triggerTrengoContactData("help_center", trengo, setTrengo, user)}>{t("drawer.FAQs")}</h6>
              </div>
              <div className="drawer-row with-icon pointer">
                <Icon iconName="tabler/mail" />
                <h6 onClick={() => triggerTrengo("email", trengo, setTrengo, user)}>{t("drawer.contact")}</h6>
              </div>
            </div>
          </div>
        </div>

        <div className={`${marginTop}`}>
          <IconLinkButton
            dataTestId="logout-button"
            iconType="logout"
            text={t("drawer.logout")}
            href="/sign-out"
            onClick={() => {
              onClose();
            }}
          />
        </div>

        <div className={marginTop}>
          <span style={{ color: "#999999", fontSize: "12px" }}>
            &#169; {year} Klim GmbH · v{appVersions[0].major}.{appVersions[0].minor}
          </span>
        </div>
      </>
    </Drawer>
  );
};

export default NavDrawer;
